import styled from 'styled-components';
import { ScrollType, ContainerProps } from './modal.types';

export const ModalContainer = styled.div<ContainerProps>`
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  position: fixed;
  z-index: 999999;

  &:focus {
    outline: none;
  }

  ${({ isCentered, scrollType }) => {
    if (isCentered) {
      const alignItems = scrollType === ScrollType.CONTAINER ? 'flex-start' : 'center';
      return `
        align-items: ${alignItems};
        display: flex;
        justify-content: center;
      `;
    }

    return;
  }}

  /**
   * When the scrollType === ScrollType.CONTAINER, the content will overflow the viewport when applicable and be scrollable on top of the backdrop
   * - The scrollbar will be on the right edge of the viewport
   * - Scrolling with the cursor over the backdrop will cause the content to scroll
   */
  ${({ scrollType }) => scrollType === ScrollType.CONTAINER && 'overflow: auto;'}
`;
